import { connect } from 'react-redux';
import getPassengerCount from 'utils/purchase/getPassengerCount';
import parseFixedFee from 'utils/purchase/parseFixedFee';
import { formatCurrency } from 'utils/currency';
import DefaultPurchasePricing from './PurchasePricing';

export const mapStateToProps = (state) => {
  const { purchase, whitelabelConfig } = state;
  const purchaseJs = purchase.toJS();
  const {
    departs,
    returns,
    roundTrip,
    passengers,
    extras,
    insuranceAmount,
    markup,
    total,
    monthlySelectedPlan,
    selectedInstallmentsPlan,
    selectedPaymentOption,
    openTicket,
    externalCouponCode,
    carbonOffsetAmount,
    ancillariesAmount,
    exchangedTotal,
    bulkTicket,
    selectedServiceLevel,
    serviceLevelAmount,
    isExchange,
  } = purchaseJs;

  const rawBreakdown = purchaseJs.exchangeFaresBreakdown;
  const exchangeSurchargesItems =
    Array.isArray(rawBreakdown) && isExchange
      ? rawBreakdown.filter((item) => Number(item?.amount) > 0)
      : [];
  const exchangeSurchargesTotal = exchangeSurchargesItems.reduce(
    (sum, item) => sum + (Number(item.amount) || 0),
    0,
  );
  const exchangeSurcharges =
    exchangeSurchargesTotal > 0
      ? { items: exchangeSurchargesItems, total: exchangeSurchargesTotal }
      : null;

  const passengerCount = getPassengerCount(
    purchase.get('passengers'),
    purchase.get('passengerSelection'),
  );
  const hasParent = purchase.get('parentId');

  const { env } = whitelabelConfig || {};
  const { currency, lang } = env || {};
  const locale = lang?.default || 'es-MX';

  const hasMixedTrips =
    departs.transportType === 'mixed' || (roundTrip && returns.transportType === 'mixed');

  const titleHeaderDescription = hasParent ? 'payment_difference' : 'payment_total';
  let titleFooterDescription = '';
  let titleTotal = Number(total);
  let installmentsFee = 0;

  if (selectedPaymentOption === 'credit_card' && monthlySelectedPlan > 1) {
    titleFooterDescription = formatCurrency(
      selectedInstallmentsPlan.monthlyPayment,
      2,
      currency,
      locale,
    );
    titleTotal = Number(selectedInstallmentsPlan.total);
    installmentsFee = Number(selectedInstallmentsPlan.fee);
  }

  // Check if we're in an overbooking scenario
  const overbooking = passengers.some((passenger) => passenger.busCategory === 'oversold');

  return {
    selectedInstallmentsPlan,
    monthlySelectedPlan,
    selectedPaymentOption,
    departs,
    hasMixedTrips,
    passengers,
    passengerCount,
    titleFooterDescription,
    titleHeaderDescription,
    titleTotal,
    exchangedTotal,
    returns,
    roundTrip,
    externalCouponCode,
    isBulkTicket: bulkTicket,
    isExchange: !!isExchange,
    overbooking,
    exchangeSurcharges,
    extras: {
      carbon: Number(carbonOffsetAmount),
      installmentsFee: Number(installmentsFee),
      insurance: Number(insuranceAmount),
      // Purchase-level products (ancillaries) total, part of the `extras` roll-up.
      ancillaries: Number(ancillariesAmount) || 0,
      markup: Number(markup),
      total: Number(extras) + Number(installmentsFee),
      serviceLevel: {
        name: selectedServiceLevel?.name,
        total: Number(serviceLevelAmount),
      },
      // Purchase-level platform-usage fee totals ({ amount, tax }, camelized from
      // the API's `fixed_fee`); already included in the purchase total.
      fixedFee: parseFixedFee(purchaseJs.fixedFee),
    },
    openTicket,
  };
};

export default connect(mapStateToProps)(DefaultPurchasePricing);
